import qs from 'qs'

export default function isLogin() {
  const query = qs.parse(location.search, { ignoreQueryPrefix: true })
  if (location.pathname === '/meinian/receive' && query.shareUrl) {
    return false
  }
  return true
}
